module.exports = __webpack_public_path__ + "static/img/materials11.ff11ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials11.png
// module id = DSBJ
// module chunks = 2